import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaUser, FaSignOutAlt, FaMusic, FaEdit, FaHeart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const Profile = ({ onLogout }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Get user data from localStorage
    const userData = sessionStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setIsLoading(false);
  }, []);

  const handleLogout = () => {
    // Clear localStorage
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    
    // Call the onLogout callback to update app state
    if (onLogout) {
      onLogout();
    }
    
    // Redirect to login page
    navigate('/login');
  };

  if (isLoading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <motion.div 
      className="auth-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="auth-background">
        <div className="music-note note-1"><FaMusic /></div>
        <div className="music-note note-2"><FaHeart /></div>
        <div className="music-note note-3"><FaMusic /></div>
      </div>
      
      <motion.div 
        className="auth-card profile-card"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <div className="profile-header">
          <div className="profile-avatar">
            <FaUser size={40} />
          </div>
          <motion.h2
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ 
              type: "spring",
              stiffness: 260,
              damping: 20 
            }}
          >
            {user.name}
          </motion.h2>
          <p className="profile-email">{user.email}</p>
        </div>
        
        <div className="profile-stats">
          <div className="stat-item">
            <h3>Favorite Songs</h3>
            <p>12</p>
          </div>
          <div className="stat-item">
            <h3>Playlists</h3>
            <p>5</p>
          </div>
          <div className="stat-item">
            <h3>Following</h3>
            <p>8</p>
          </div>
        </div>
        
        <div className="profile-actions">
          <motion.button 
            className="profile-button edit-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaEdit /> Edit Profile
          </motion.button>
          
          <motion.button 
            className="profile-button logout-button"
            onClick={handleLogout}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaSignOutAlt /> Logout
          </motion.button>
        </div>
        
        <div className="recent-activity">
          <h3>Recent Activity</h3>
          <div className="activity-list">
            <div className="activity-item">
              <FaMusic className="activity-icon" />
              <div className="activity-content">
                <p className="activity-title">Liked "Bohemian Rhapsody"</p>
                <p className="activity-time">2 days ago</p>
              </div>
            </div>
            <div className="activity-item">
              <FaMusic className="activity-icon" />
              <div className="activity-content">
                <p className="activity-title">Created "Chill Vibes" playlist</p>
                <p className="activity-time">1 week ago</p>
              </div>
            </div>
            <div className="activity-item">
              <FaMusic className="activity-icon" />
              <div className="activity-content">
                <p className="activity-title">Followed Artist "The Weeknd"</p>
                <p className="activity-time">2 weeks ago</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Profile;
